import { DragEvent, forwardRef, RefObject, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IUploadFile } from 'store/models/general-models';
import { SVG } from 'components';
import { DndFile } from '../../components';
import { DNDButton } from '../../file-uploader.styled';
import { DragWrapper, Wrapper } from './dnd-view.styled';
import { ReactComponent as addImage } from 'assets/icons/add_image.svg';

interface IProps {
  files: IUploadFile[];
  limit?: number;
  onDeleteFile: (file: IUploadFile) => void;
  onDragComplete?: (files: IUploadFile[]) => void;
}

export const DndView = observer(
  forwardRef<HTMLInputElement, IProps>(
    ({ files, limit, onDeleteFile, onDragComplete }, ref) => {
      const [list, setList] = useState<IUploadFile[]>([]);
      const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
      const isDNDDisabled = list.some((file: IUploadFile) => file.isPending);

      useEffect(() => {
        setDraggedIndex(null);
      }, []);

      useEffect(() => {
        setList(files);
        setDraggedIndex(null);
      }, [files]);

      const handleDragStart = (index: number) => {
        setDraggedIndex(index);
      };

      const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
      };

      const handleDrop = (droppedIndex: number) => {
        if (draggedIndex === null || draggedIndex === droppedIndex) {
          return;
        }

        const updatedList = [...list];
        const [movedFile] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(droppedIndex, 0, movedFile);

        setList(updatedList);
        onDragComplete?.(updatedList);
        setDraggedIndex(null);
      };

      return (
        <Wrapper isDisabled={isDNDDisabled}>
          {list.map((file: IUploadFile, index: number) => (
            <DragWrapper
              key={file.name}
              draggable
              onDragStart={() => handleDragStart(index)}
              onDragOver={handleDragOver}
              onDrop={() => handleDrop(index)}
              onDragEnd={() => setDraggedIndex(null)}
            >
              <DndFile
                file={file}
                inProccess={file.isPending}
                readOnly={false}
                onDeleteFile={onDeleteFile}
              />
            </DragWrapper>
          ))}
          {limit !== files.length && (
            <DNDButton
              key={'dnd-button'}
              disabled={false}
              onClick={() =>
                (ref as RefObject<HTMLInputElement>).current?.click()
              }
            >
              <SVG
                src={addImage}
                props={{
                  color: 'currentColor',
                  cursor: 'inherit',
                }}
              />
              Добавить изображение
            </DNDButton>
          )}
        </Wrapper>
      );
    }
  )
);
